<template>
    <div class="page-table listPage mainDiv mb-30" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">
            MULTIPLE PRODUCTS

            <div class="tanimlamaButon">
                <el-tooltip :content='$t("src.views.apps.genel.refresh")'
                    :open-delay="500"
                    placement="top">
                    <el-button
                    v-on:click="refreshPage()"
                    size="mini"
                    type="text"
                    icon="el-icon-refresh">
                    </el-button>
                </el-tooltip>
            </div>
        </div>

        <el-row :gutter="10">
            <el-col :lg="update ? 18 : 24" :md="update ? 18 : 24" :sm="24" :xs="24">
                <div class="page-header card-base card-shadow--medium animated fadeInUp" v-loading="loading || stateLoading"
                :element-loading-text='loading ? "Multiple Products List is Loading. Please Wait" : "Multiple Products Status is Changing. Please Wait"'
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 1)">
                <el-row class="mt-0 mb-10">
                    <el-col :lg="16" :md="16" :sm="24" :xs="24">
                        <div>
                            <el-radio-group size="small" v-on:change="handleChange($event)" v-model="radio" fill="#E5F5F9" text-color="gray">
                                <el-radio-button label="1">
                                    <i class="mdi mdi-page-next mdi-18px" style="color: #13ce66; margin-right: 5px"></i>
                                    <transition name="slide-fade">
                                        <label v-if="selectIcon == '1'">Live</label>
                                    </transition>
                                </el-radio-button>

                                <el-radio-button label="0">
                                    <i class="mdi mdi-page-next mdi-18px" style="color: #ec205f; margin-right: 5px"></i>
                                    <transition name="slide-fade">
                                        <label v-if="selectIcon == '0'">Draft</label>
                                    </transition>
                                </el-radio-button>

                            </el-radio-group>
                        </div>
                    </el-col>

                    <el-col :lg="8" :md="8" :sm="24" :xs="24">
                        <el-col :lg="24" :md="24" :sm="24" :xs="24">
                            <ul class="islemler">
                                <li class="duzenle">
                                    <i class="mdi mdi-pen"></i> {{$t("src.views.apps.rakamlar.islem.duzenle")}}
                                </li>
                                <li v-if="selectIcon == '1'" class="sil">
                                    <i class="mdi mdi-trash-can danger-color"></i> Move to Draft
                                </li>
                                <li v-else class="aktif">
                                    <i class="mdi mdi-play"></i> Move to Live
                                </li>
                            </ul>
                        </el-col>
                    </el-col>
                </el-row>

                <el-table border stripe :data="multipleProductList" style="width: 100%" v-if="multipleProductList.length > 0">
                    <el-table-column
                        :label='$t("src.views.apps.genel.sira")'
                        type="index"
                        :index="indexMethod"
                        width="65">
                    </el-table-column>
                    <el-table-column
                        label='ID'
                        prop="cokluUrunID"
                        width="auto">
                    </el-table-column>

                    <el-table-column
                        label='Product ID'
                        prop="urunID"
                        width="95">
                    </el-table-column>
                    
                    <el-table-column
                        prop="urunBaslik"
                        label='Product Name'
                        width="250">
                        <template slot-scope="prop">
                            <div class="new-line-text">
                                {{prop.row.urunBaslik + " deneme 1  3 4 dddfdffddf ssssssssss dd"}}
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="cokluUrunBirim"
                        label='Unit'
                        width="100">
                    </el-table-column>
                    
                    <el-table-column
                        label='Piece'
                        prop="cokluAdet"
                        width="90">
                    </el-table-column>

                    <el-table-column
                        label='Unit Price'
                        prop="cokluUrunFiyat"
                        width="100">
                        <template slot-scope="prop">
                            <b>{{prop.row.cokluUrunFiyat + ' $'}}</b>
                        </template>
                    </el-table-column>

                    <el-table-column
                        label='Total Price'
                        prop="cokluUrunCokluFiyat"
                        width="110">
                        <template slot-scope="prop">
                            <b>{{prop.row.cokluUrunCokluFiyat + ' $'}}</b>
                        </template>
                    </el-table-column>

                    <el-table-column
                        label='Period'
                        prop="cokluUrunSure"
                        width="auto">
                        <template slot-scope="prop">
                            <div class="danger-color" v-if="prop.row.cokluUrunSure == '1'">
                                YES
                            </div>
                            <div v-if="prop.row.cokluUrunSure == '0'">
                                NO
                            </div>
                        </template>
                    </el-table-column>
                    
                    <el-table-column
                        prop="baslamaTarihi"
                        label='Start Date'
                        width="120">
                        <template slot-scope="prop">
                            <div v-if="prop.row.cokluUrunSure == '1'">{{prop.row.baslamaTarihi}}</div>
                            <div v-if="prop.row.cokluUrunSure == '1'">{{prop.row.baslamaSaati}}</div>
                            <div v-else>-</div>
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="bitisTarihi"
                        label='End Date'
                        width="120">
                        <template slot-scope="prop">
                            <div v-if="prop.row.cokluUrunSure == '1'">{{prop.row.bitmeTarihi}}</div>
                            <div v-if="prop.row.cokluUrunSure == '1'">{{prop.row.bitmeSaati}}</div>
                            <div v-else>-</div>
                        </template>
                    </el-table-column>
                   
                    <el-table-column
                        :label='$t("src.views.apps.genel.islem")'
                        fixed="right"
                        align="right"
                        width="120">
                        <template slot-scope="scope">
                            <el-tooltip :content='$t("src.views.apps.rakamlar.islem.duzenle")' :open-delay="500" placement="bottom">
                                <el-button
                                    v-on:click="selectionIndex=scope.$index; selection=scope.row; updateStart(scope.row, 'multipleForm'); "
                                    type="text"
                                    style="color: #f7ba2a; margin-left: 15px !important;"
                                    icon="mdi mdi-pen mdi-24px">
                                </el-button>
                            </el-tooltip>
                            <el-tooltip v-if="selectIcon == '0'" :content='"Move to Live"' :open-delay="500" placement="bottom">
                                <el-button
                                    v-on:click="statusChange(scope.row,'1')"
                                    type="text"
                                    class="buttonDel"
                                    style="margin-left: 15px !important; color: #13ce66"
                                    icon="mdi mdi-play mdi-24px">
                                </el-button>
                            </el-tooltip>

                            <el-tooltip v-if="selectIcon == '1'" :content='"Move to Draft"' :open-delay="500" placement="bottom">
                                <el-button
                                    v-on:click="statusChange(scope.row,'0')"
                                    type="text"
                                    class="buttonDel danger-color"
                                    style="margin-left: 15px !important;"
                                    icon="mdi mdi-trash-can mdi-24px">
                                </el-button>
                            </el-tooltip>
                            
                        </template>
                     </el-table-column>
                </el-table>

                <div v-else style="height: 100px; display: flex; justify-content: center; align-items: center">
                    There is no multiple selection to show.
                </div>

                <el-pagination
                    v-if="multipleProductList.length > 0"
                    background
                    layout="sizes,prev, pager, next, jumper, total"
                    :total="total"
                    @size-change="handleSizeChange"
                    @current-change="pageChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page.sync="page"
                    :next-click.sync="page"
                    :prev-click.sync="page"
                    @next-click="pageChange"
                    @prev-click="pageChange">
                </el-pagination>
            </div>
            </el-col>

            <el-col v-if="update" :lg="6" :md="6" :sm="24" :xs="24">
                <div class="card-base card-shadow--medium demo-box bg-white animated fadeInRight pb-20" style="border-radius: 0px !important; overflow: visible !important" v-loading="updateLoading"
                :element-loading-text='"Campaign is Updating. Please Wait"'
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 1)">

                    <div class="yanmenu-title">
                        <p>Update</p>
                    </div>

                    <el-form status-icon :model="multipleForm" :rules="multipleFormRules" ref="multipleListForm" class="demo-ruleForm">
                        <el-row :gutter="10" class="p-5">
                            <el-col class="col-p">
                                <el-col :lg="12" :md="12" :sm="12" :xs="12">
                                    <el-form-item :label='"Piece"' prop="adet">:
                                        <el-input v-model="multipleForm.adet" v-mask="'######'" :placeholder='"Enter Piece"'></el-input>
                                    </el-form-item>
                                </el-col>

                                <el-col :lg="12" :md="12" :sm="12" :xs="12">
                                    <!-- urun birimi -->
                                    <el-form-item :label='"Unit"' prop="birim">
                                        <el-select v-model="multipleForm.birim" style="width: 100%" placeholder="Unit">
                                            <el-option label="Box" value="Box"></el-option>
                                            <el-option label="Piece" value="Peace"></el-option>
                                            <el-option label="Parcel" value="Parcel"></el-option>
                                            <el-option label="Package" value="Package"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>

                                <el-col :lg="24" :md="24" :sm="24" :xs="24">
                                    <el-form-item :label='"Unit Price"' prop="birimFiyat">
                                        <el-input placeholder="Unit Price"  v-mask="['#,##', ' ##,##', ' ###,##', '#.###,##', '##.###,##', '###.###,##']"  v-model="multipleForm.birimFiyat"></el-input>
                                    </el-form-item>
                                </el-col>

                                <el-col :lg="17" :md="17" :sm="17" :xs="17" >
                                    <el-form-item :label='"Period"' prop="sure">
                                        <el-tooltip :content='"Is it valid for a certain period of time?"' :open-delay="250" placement="right">
                                            <el-checkbox-button label="Have an Expiration Date" v-model="multipleForm.sure"></el-checkbox-button>
                                        </el-tooltip>
                                    </el-form-item>
                                </el-col>

                                
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" v-if="multipleForm.sure">
                                    <el-form-item :label='"Start Date"' prop="baslangicTarihi">
                                        <el-date-picker v-model="multipleForm.baslangicTarihi" type="datetime" placeholder="Start Date" style="width: 100%"></el-date-picker>
                                    </el-form-item>
                                </el-col>
                                
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" v-if="multipleForm.sure">
                                    <el-form-item :label='"End Date"' prop="bitisTarihi">
                                        <el-date-picker v-model="multipleForm.bitisTarihi" type="datetime" placeholder="End Date" style="width: 100%"></el-date-picker>
                                    </el-form-item>
                                </el-col>

                                <el-col :lg="24" :md="24" :sm="24" :xs="24" >
                                    <div style="display: flex; justify-content: end">
                                        <el-button type="danger" @click="cancelUpdate('multipleListForm')">Cancel</el-button>
                                        <!-- <el-button type="success" v-if="!update" @click="addCampaign('multipleListForm')">Add</el-button> -->
                                        <el-button type="success" @click="updateMultipleSelect('multipleListForm')">Update</el-button>
                                    </div>
                                </el-col>
                            </el-col>
                        </el-row>

                    </el-form>
                </div>
            </el-col>
        </el-row>

    </div>
</template>

<script>
    import cokluUrunService from '../../../WSProvider/CokluUrunService'
    import notification from '../../../notification'
    import functions from '../../../functions'
    import JQuery from 'jquery';
    import EventBus from '@/components/event-bus'

    let $ = JQuery;
    import '@fortawesome/fontawesome-free/css/all.css'
    import '@fortawesome/fontawesome-free/js/all.js'

    var moment = require('moment')

    export default {
        name: "Campaigns",
        components: {
        },
        mounted() {
            this.getMultipleList()
        },
        watch: {
            page(val) {
                this.postPage = (val - 1) * this.sizes;
            }
        },
        data() {
            return {
                update: false,

                loading: false,
                updateLoading: false,
                stateLoading: false,
                addLoading: false,
                selectIcon: '1',
                radio: '1',
                multipleProductList: [],
                selection: '',
                selectionIndex: '',

                sizes: 10,
                page: 0,
                postPage: 0,
                total: null,

                multipleForm: {
                    cokluUrunID : '',
                    adet: '',
                    birim: '',
                    birimFiyat: '',
                    cokluFiyat: '',
                    sure: '',
                    baslangicTarihi: '',
                    bitisTarihi: '',
                    durum: '',
                },
                multipleFormRules: {},

            }
        },
        methods: {
            cancelUpdate(formName){
                this.$confirm("Are you sure you want to reset form?", this.$t("src.views.apps.marka.tanimlama.warning"), {
                    confirmButtonText: this.$t("src.views.apps.genel.yes"),
                    cancelButtonText: this.$t("src.views.apps.genel.no"),
                    type: 'warning'
                }).then(() => {
                    this.vazgec(formName);
                }).catch(() => {

                })
            },

            updateMultipleSelect(formName){
                this.$confirm("Are you sure want to update multiple selection?", this.$t("src.views.apps.marka.tanimlama.warning"), {
                    confirmButtonText: this.$t("src.views.apps.genel.yes"),
                    cancelButtonText: this.$t("src.views.apps.genel.no"),
                    type: 'warning'
                }).then(() => {
                     this.$refs[formName].validate((valid, errors) => {
                        if(valid){
                            // cokluTekUrunGuncelle(cokluUrunID, adet, birim, fiyat, cokluFiyat, sure, baslangicTarihi, bitisTarihi, durum){
                            this.multipleForm.baslangicTarihi =  moment(this.multipleForm.baslangicTarihi).format("YYYY-MM-DD hh:mm:ss")
                            this.multipleForm.bitisTarihi = moment(this.multipleForm.bitisTarihi).format("YYYY-MM-DD hh:mm:ss")
                            this.multipleForm.cokluFiyat = parseFloat(this.multipleForm.adet) * parseFloat(this.multipleForm.birimFiyat)

                            var birimFiyat = functions.formatMoney(this.multipleForm.birimFiyat)
                            var cokluFiyat = functions.formatMoney( this.multipleForm.cokluFiyat)

                            cokluUrunService.cokluTekUrunGuncelle(this.multipleForm.cokluUrunID, this.multipleForm.adet, this.multipleForm.birim, birimFiyat, cokluFiyat, this.multipleForm.sure ? '1':'0', this.multipleForm.sure ? this.multipleForm.baslangicTarihi : '', this.multipleForm.sure ? this.multipleForm.bitisTarihi : '', this.multipleForm.durum).then((response) => {
                                if(response.status == 200){
                                    notification.Status("success", this, "Multiple selection successfully updated.");
                                    this.multipleForm.durum == this.selectIcon ? this.getMultipleList() : '';
                                    this.vazgec(formName);
                                }
                                this.getMultipleList();
                            }).catch(err => {
                                if(err.responseJSON){
                                    let error = err.responseJSON
                                    if(error.status == 401){
                                        notification.Status(150, this);
                                    }
                                    else notification.Status("errorMsg", this, error.errMsg);
                                }else{
                                    // notification.Status(503, this)
                                }
                            })
                        }else{
                            for(var k in errors){
                                errors[k].forEach((element) => {
                                    notification.Status( "warning", this, element.message);
                                })  
                            }
                        }
                    })
                }).catch(() => {

                })
            },


            refreshPage(){
                this.loading = false;
                this.stateLoading = false;
                this.addLoading = false;
                this.updateLoading = false;
                this.page = 1;
                this.postPage = 0;
                this.update = false;
                this.getMultipleList();
            },

            handleChange(event) {
                this.selectIcon = event;
                this.postPage = 0;
                this.getMultipleList();
            },

            getMultipleList() {
                this.loading = true;
                cokluUrunService.cokluUrunListele(this.selectIcon, this.postPage, this.sizes).then((response) => {
                    if (response.status == 200) {
                        localStorage.setItem("userDataDosPharmacy", response.token);
                        response.data.data.forEach(el => {
                            if(el.cokluUrunSure == '1'){
                                el.baslamaSaati = moment(el.baslangicTarihi).format('HH:MM:SS')
                                el.baslamaTarihi = moment(el.baslangicTarihi).format("DD-MM-YYYY")
                                el.bitmeSaati = moment(el.bitisTarihi).format('HH:MM:SS')
                                el.bitmeTarihi = moment(el.bitisTarihi).format("DD-MM-YYYY")
                            }
                        })
                        this.multipleProductList = response.data.data;
                        this.total = response.data.count
                    }
                    this.loading = false;
                }).catch(err => {
                    if(err.responseJSON){
                        let error = err.responseJSON
                        if(error.status == 401){
                            notification.Status(150, this);
                        }else if(error.status == 404){
                            this.multipleProductList = [];
                        }
                        else notification.Status("errorMsg", this, error.errMsg)
                    }else{
                        // notification.Status(503, this)
                    }
                    this.loading = false;
                })
            },


            updateStart(scope, formName) {
                // if(scope.cokluUrunFiyat.includes(',')){
                //     var eskiF = scope.cokluUrunFiyat
                //     var eskiFiyatStrip = eskiF.substring(eskiF.indexOf(','), eskiF.length);
                //     if(eskiFiyatStrip.length == 3){
                //         this.multipleForm.birimFiyat = scope.cokluUrunFiyat
                //     }
                //     else if(eskiFiyatStrip.length == 2){
                //         this.multipleForm.birimFiyat = scope.cokluUrunFiyat + '0'
                //     }
                //     else if(eskiFiyatStrip.length == 1){
                //         this.multipleForm.birimFiyat = scope.cokluUrunFiyat + '00'
                //     }
                // }else{
                //     this.multipleForm.birimFiyat = scope.cokluUrunFiyat + ',00'
                // }
                this.multipleForm.birimFiyat = functions.decodeMoney(scope.cokluUrunFiyat)

                this.multipleForm.adet = scope.cokluAdet;
                this.multipleForm.durum = scope.cokluUrunDurum;
                this.multipleForm.birim = scope.cokluUrunBirim;
                this.multipleForm.cokluFiyat = scope.cokluUrunCokluFiyat
                this.multipleForm.sure = scope.cokluUrunSure == '1' ? true : false
                if(this.multipleForm.sure && scope.baslangicTarihi != '' && scope.bitisTarihi != ''){
                    this.multipleForm.baslangicTarihi = scope.baslangicTarihi;
                    this.multipleForm.bitisTarihi = scope.bitisTarihi;
                }else{
                    this.multipleForm.baslangicTarihi = '';
                    this.multipleForm.bitisTarihi = '';
                }
                this.multipleForm.cokluUrunID = scope.cokluUrunID

                this.update = true
                document.querySelector('.scrollable').scrollTo({top: 0, behavior: 'smooth'});
            },

            vazgec(formName) {
                this.updateLoading = false;
                this.stateLoading = false;
                this.loading = false;
                this.update = false;

                this.$refs[formName].resetFields();
            },

            statusChange(selection ,durum) {
                var durumText = durum == '1' ? " as Live?" : " as Draft?"
                this.$confirm("Are you sure you want to update number's status" + durumText, this.$t("src.views.apps.marka.tanimlama.warning"), {
                    confirmButtonText: this.$t("src.views.apps.genel.yes"),
                    cancelButtonText: this.$t("src.views.apps.genel.no"),
                    type: 'warning'
                }).then(() => {
                    this.stateLoading = true;
                    cokluUrunService.cokluUrunDurumGuncelle(durum, selection.cokluUrunID).then(response => {
                        if (response.status == 200) {
                            localStorage.setItem("userDataDosPharmacy", response.token)
                            this.getMultipleList();
                            this.stateLoading = false;
                        }
                        notification.Status("success", this, response.msg)
                    }).catch(err => {
                        if(err.responseJSON){
                            let error = err.responseJSON
                            if(error.status == 401){
                                notification.Status(150, this);
                            }
                            else notification.Status("errorMsg", this, error.errMsg)
                        }else{
                            // notification.Status(503, this)
                        }
                        this.stateLoading = false;
                    })
                })
            },

            formTemizle(formName) {
                this.$refs[formName].resetFields();
            },

           handleSizeChange(val) {
                this.sizes = val;
                this.getMultipleList();
            },

            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getMultipleList();
                document.querySelector('.scrollable').scrollTo({top: 0, behavior: 'smooth'});
            },

            indexMethod(index){
                return ((this.page - 1)* 10) + index + 1;
            },
            
        }
    }
</script>
<style lang="scss" scoped>
@import '../../../assets/scss/_variables';
    .el-pagination {
        margin-top: 20px;
        float: right;
    }
</style>

<style scoped>
    .yorum-expand{
        word-wrap: break-word;
    }

</style>